// extracted by mini-css-extract-plugin
module.exports = {"component":"Message_component__3IonY","header":"Message_header__R2awc","detail":"Message_detail__2chsA","value":"Message_value__20Hje","warn":"Message_warn__1DbkU"};